import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateCustomFieldDefinitionInput, CustomFieldDefinitionResponse, CustomFieldEntityType, UpdateCustomFieldDefinitionInput } from '@orion/contracts';
import { api } from '../../../lib/api-client.js';

const KEY = ['custom-fields'];

export function useCustomFieldsQuery(entityType: string) {
  return useQuery({
    queryKey: [...KEY, entityType],
    queryFn: () => api.get<CustomFieldDefinitionResponse[]>(`/custom-fields?entityType=${entityType}`),
  });
}

export function useCreateCustomField() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateCustomFieldDefinitionInput) => api.post<CustomFieldDefinitionResponse>('/custom-fields', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateCustomField() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateCustomFieldDefinitionInput }) => api.patch<CustomFieldDefinitionResponse>(`/custom-fields/${id}`, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useArchiveCustomField() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<void>(`/custom-fields/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useReorderCustomFields() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ entityType, orderedIds }: { entityType: CustomFieldEntityType; orderedIds: string[] }) =>
      api.patch<void>('/custom-fields/reorder', { entityType, orderedIds }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}
